const {
  hideElementsBySelector,
  showElementsBySelector,
  addVisibilityHiddenBySelector,
  removeVisibilityHiddenBySelector,
} = require('../common/utils/dom');
const showInteraction = require('../interactions/show');

const blocksToNotVisibleSelector =
  '.header-no-menu__nav-row, .checkout-container__breadcrumbs, .checkout-container__summary';
const onlyFormBackBtnSelector = '.only-form-back-btn';
const slotPromoCheckoutSelector = '.slot-promo-checkout-message';

/* Removes visibility but preserves structure */
function changeViewToOnlyForm() {
  const checkoutMain = document.getElementById('checkout-main');
  if (checkoutMain) {
    checkoutMain.setAttribute('data-only-form-view', true);
  }
  hideElementsBySelector(slotPromoCheckoutSelector);
  showElementsBySelector(onlyFormBackBtnSelector);
  addVisibilityHiddenBySelector(blocksToNotVisibleSelector);
}

/* Restores visibility of normal checkout view */
function changeViewToNormal() {
  const checkoutMain = document.getElementById('checkout-main');
  if (checkoutMain) {
    checkoutMain.setAttribute('data-only-form-view', false);
  }
  showElementsBySelector(slotPromoCheckoutSelector);
  hideElementsBySelector(onlyFormBackBtnSelector);
  removeVisibilityHiddenBySelector(blocksToNotVisibleSelector);
}

/**
 * Sets the visibility of checkout sections based on the current stage.
 * @param {string} currentStage - The current checkout stage.
 */
function setStageView(currentStage) {
  const allStageBlocks = document.querySelectorAll('[data-stage-container]');
  allStageBlocks.forEach((blockElement) => {
    const blockStages = blockElement.dataset.stageContainer.split('/');
    const shouldShow = blockStages.includes(currentStage);
    if (shouldShow) {
      showInteraction.show(blockElement);
    } else {
      showInteraction.hide(blockElement);
    }
  });
}

module.exports = {
  methods: {
    changeViewToOnlyForm,
    changeViewToNormal,
    setStageView,
  },
};
